import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { Information, INFORMATION_SIZE } from 'src/components/Information';
import { StonlyIcon } from 'src/components/StonlyIcon';
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import { useStyles } from './useStyles';

export const PanelTitle = ({
  className,
  classes,
  title,
  hint,
  optional,
  modified,
  titleStonlyId,
  titleBold,
}) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className, { [styles.titleBold]: titleBold })}>
      {title && (
        <TruncatedTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {title}
        </TruncatedTypography>
      )}

      {optional && (
        <CustomTypography
          className={styles.extra}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          (optional)
        </CustomTypography>
      )}
      {modified && (
        <CustomTypography
          className={styles.extra}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          (modified)
        </CustomTypography>
      )}

      {hint && (
        <Information
          size={INFORMATION_SIZE.small}
          content={hint}
        />
      )}

      {titleStonlyId && (
        <StonlyIcon
          className={styles.stonlyIcon}
          stonlyId={titleStonlyId}
        />
      )}
    </div>
  );
};

PanelTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  optional: PropTypes.bool,
  titleStonlyId: PropTypes.string,
  modified: PropTypes.bool,
  titleBold: PropTypes.bool,
};
PanelTitle.defaultProps = {
  className: '',
  classes: null,
  title: '',
  hint: '',
  optional: false,
  titleStonlyId: '',
  modified: false,
  titleBold: false,
};
